import React from "react";
import { motion } from "framer-motion";
import food from "@/assets/images/food.png";
import money from "@/assets/images/money .png"; // fixed spacing in filename
import env from "@/assets/images/envirnmnt.png";

const FeaturesSection: React.FC = () => {
  const features = [
    {
      img: food,
      alt: "Rescue Food",
      title: (
        <>
          Order from Your <br /> Favourite Restaurants & Stores
        </>
      ),
    },
    {
      img: money,
      alt: "Save Money",
      title: "Save More Every Order",
    },
    {
      img: env,
      alt: "Save Environment",
      title: "Support a Sustainable Future",
    },
  ];

  return (
    <section className="bg-gradient-to-r from-emerald-500 to-teal-700 text-white py-20 px-6 overflow-hidden">
      {/* Heading */}
      <motion.div
        className="text-center max-w-4xl mx-auto mb-16"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <p className="text-lg md:text-3xl font-bold leading-relaxed">
          <span className="text-green-500 underline decoration-white">Feeling hungry!</span> Grab your Mystery
          bag at nearby restaurants, all at a fraction of less than half of the
          original price.
        </p>
      </motion.div>

      {/* Feature Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center max-w-6xl mx-auto mt-20">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className="flex flex-col items-center"
            initial={{ opacity: 0, y: 50, scale: 0.9 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            transition={{
              duration: 0.8,
              delay: index * 0.3,
              ease: "easeOut",
            }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.img
              src={feature.img}
              alt={feature.alt}
              className="mx-auto mb-6 w-64 h-64 object-contain"
              whileHover={{ scale: 1.1, rotate: 2 }}
              transition={{ type: "spring", stiffness: 200 }}
            />
            <motion.h3
              className="text-lg md:text-2xl font-medium leading-snug"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                duration: 0.6,
                delay: index * 0.4 + 0.2,
              }}
              viewport={{ once: true }}
            >
              {feature.title}
            </motion.h3>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
